import {initialShiftTemplatesState, IShiftTemplatesState} from '@app/core/store/state/shift-templates.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EShiftTemplatesActions, ShiftTemplatesActions} from '@app/core/store/actions/shift-templates.actions';

export const shiftTemplatesReducers = (
	state = initialShiftTemplatesState,
	action: ShiftTemplatesActions | ErrorActions,
): IShiftTemplatesState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EShiftTemplatesActions.SetCopyingWeek: {
			return {
				...state,
				copyingWeek: action.copyingWeek
			};
		}
		case EShiftTemplatesActions.GetTemplates: {
			return {
				...state,
				isLoading: true
			};
		}
		case EShiftTemplatesActions.GetTemplatesSuccess: {
			return {
				...state,
				isLoading: false,
				shiftTemplates: action.templates
			};
		}
		case EShiftTemplatesActions.CreateShiftTemplateSuccess: {
			return {
				...state,
				shiftTemplates: [action.shiftTemplate, ...state.shiftTemplates]
			};
		}
		case EShiftTemplatesActions.DeleteShiftTemplateSuccess: {
			return {
				...state,
				shiftTemplates: state.shiftTemplates.filter(st => st.id !== action.shiftTemplateId)
			};
		}
		default:
			return state;
	}
};
